import type { CSSProperties } from 'react';
import { theme } from 'antd';
import { PosTooltip } from 'pos-client/components/shared/General/PosTooltip.tsx';

interface PosLabelProps {
  tooltip?: string | React.ReactNode;
  label: string | React.ReactNode;
  boldLabel?: boolean;
  style?: CSSProperties;
}

export const PosLabel = ({
  tooltip,
  label,
  boldLabel,
  style,
}: PosLabelProps) => {
  const { token } = theme.useToken();

  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: token.marginXXS,
        fontWeight: boldLabel ? 'bold' : 'normal',
        ...style,
      }}
    >
      {label}
      {tooltip && <PosTooltip title={tooltip} showIcon />}
    </label>
  );
};
